import { EyeIcon, ShieldFlash, SignalIcon } from "@theprelude/ds";
import { ExpectedName } from "@/lib/odp";

export function ExpectedResultIcon({
  name,
  className,
}: {
  name: ExpectedName;
  className?: string;
}) {
  if (name === "observed") {
    return <EyeIcon className={className} />;
  }

  if (name === "detected") {
    return <SignalIcon className={className} />;
  }

  if (name === "prevented") {
    return <ShieldFlash className={className} />;
  }
}
